import { render, staticRenderFns } from "./HeadBanner.vue?vue&type=template&id=c704d252&scoped=true&"
import script from "./HeadBanner.vue?vue&type=script&lang=js&"
export * from "./HeadBanner.vue?vue&type=script&lang=js&"
import style0 from "./HeadBanner.vue?vue&type=style&index=0&id=c704d252&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c704d252",
  null
  
)

export default component.exports